import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { FilterOption, ignoreValue } from '@k2/common/filters';

@Component({
    selector: 'select-filter',
    templateUrl: 'select-filter.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectFilterComponent {
  @Input() control: UntypedFormControl;
  @Input() options: FilterOption[];
  @Input() placeholder = 'all';
  @Input() displayPlaceholder = true;

  get ignoreValue() {
    return ignoreValue;
  }
}
